export default __webpack_public_path__ + "static/media/VideoBook.7c1c266a27c15f6a7d8956ae949bb7d5.webp";